<template>
  <v-container fluid align-start ma-0 pa-2 class="container-height">
    <v-row no-gutters fill-height>
      <v-col cols="12">
        <i-card-vertical headerTitle=" B.2 Request Material Follow Up" :useBtnList="[
                    'btnRetrieve', //Retrieve
                    'btnExcel'
                ]" @btnRetrieve="btnRetrieve()" @btnExcel="btnExcel()">
          <template v-slot:body>
            <v-layout column overflow-auto>
              <v-row dense>
                <v-col cols="12" class="pa-0">
                  <i-card-top class="d-md-flex" outlined>
                    <template v-slot:body>
                      <v-layout column>
                        <v-row no-gutters class="center pa-2 pb-2">
                          <v-icon small color="blue" class="pb-1">mdi-circle</v-icon>
                          <span class="pa-1 subTitle"> Material Code/Spec : </span>
                          <v-col cols="2">
                            <v-text-field v-model="matlCd" dense outlined hide-details="auto"
                                          clearable height="32"  @keydown.enter="btnRetrieve()"/>
                          </v-col>
                          <v-icon small color="blue" class="pl-2 pb-0">mdi-circle</v-icon>
                          <span class="pa-1 pt-2 subTitle">Duration div : </span>
                          <v-col cols="1">
                            <v-select v-model="reqDiv.select" :items="reqDiv.items"
                                      item-text="name" item-value="cd" return-object single-line
                                      outlined dense @change="btnRetrieve()"/>
                          </v-col>
                          <v-col cols="2"  class="pl-1">
                            <DxDateBox :value="startDate" height="30px"
                                       display-format="yyyy-MM-dd" :acceptCustomValue="false"
                                       @value-changed="e => { reqDtFrom = e.value && getStrFormat(e.value) }" />
                          </v-col>
                          <span class="pa-1 pt-2 subTitle"> ~ </span>
                          <v-col cols="2">
                            <DxDateBox :value="endDate" height="30px"
                                       display-format="yyyy-MM-dd" :acceptCustomValue="false"
                                       @value-changed="e => { reqDtFrom = e.value && getEndFormat(e.value) }" />
                          </v-col>
                          <v-icon small color="blue" class="pl-2 pb-1">mdi-circle</v-icon>
                          <span class="pa-1 subTitle"> Factory : </span>
                          <v-col cols="1">
                            <v-select v-model="fact.select" :items="fact.items"
                                      item-text="name" item-value="cd" return-object single-line
                                      outlined dense @change="btnRetrieve()"/>
                          </v-col>
                        </v-row>

                      </v-layout>
                    </template>
                  </i-card-top>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="12" class="pa-0">
                  <DxDataGrid id="epmsb200" class="listBox" :ref="epmsb200Ref" :data-source="gridMainList"
                              :remote-operations="false" :hover-state-enabled="true" :allow-column-resizing="true"
                              :allow-column-reordering="true" :row-alternation-enabled="true" :show-borders="true"
                              :width="grid.width" :show-row-lines="true" key-expr="id" :focused-row-enabled="true"
                              :column-hiding-enabled="false" :selection="{ mode: 'none' }"
                              :sorting="{ mode: 'none' }" :word-wrap-enabled="true" @cellPrepared="cellPrepared">

                    <DxColumn data-field="rnum" caption="No" width="7%" data-type="string"
                              :allow-editing="false" alignment="center" />

                    <DxColumn data-field="facNm" caption="Factory" width="10%" data-type="string"
                              :allow-editing="false" alignment="center" />

                    <DxColumn caption="Request Information" width="50%" data-type="string" :allow-editing="false"
                              alignment="center" :visible="true">
                      <DxColumn caption="Request No" width="10%" data-type="string" :allow-editing="false"
                                alignment="center" :visible="true">
                        <DxColumn data-field="reqNo" caption="Sent HVS Date" width="10%" data-type="string"
                                  :allow-editing="false" alignment="center" :visible="true"
                                  header-cell-template="hvsDteTemplate" />
                      </DxColumn>
                      <DxColumn caption="Material Spec" width="30%" data-type="string" :allow-editing="false"
                                alignment="center" :visible="true">
                        <DxColumn data-field="shipNo" caption="Ship no" width="8%" data-type="string"
                                  :allow-editing="false" alignment="center" :visible="true"/>
                        <DxColumn data-field="pntCd" caption="PNT Code" width="7%" data-type="string"
                                  :allow-editing="false" alignment="center" :visible="true" header-cell-template="pntCdTemplate" />
                        <DxColumn data-field="matlCd" caption="Material Code" width="12%" data-type="string"
                                  :allow-editing="false" alignment="center" :visible="true" header-cell-template="matlCdTemplate"/>
                        <DxColumn data-field="perCanLtr" caption="Can/Liter" width="8%" data-type="string"
                                  :allow-editing="false" alignment="center" :visible="true"/>
                        <DxColumn data-field="qty" caption="Req.Qty" width="8%" data-type="string"
                                  :allow-editing="false" alignment="center" :visible="true"/>
                        <DxColumn data-field="canQty" caption="Req.Can" width="8%" data-type="string"
                                  :allow-editing="false" alignment="center" :visible="true" header-cell-template="canQtyTemplate"/>
                        <DxColumn data-field="reqDlyDte" caption="Req.Dly.Date" width="10%" data-type="string"
                                  :allow-editing="false" alignment="center" :visible="true" header-cell-template="reqDlyDteTemplate"/>
                      </DxColumn>
                    </DxColumn>

                    <template #hvsDteTemplate >
                      <div>Sent HVS<br/>Date</div>
                    </template>

                    <template #pntCdTemplate>
                      <div>PNT<br />Code</div>
                    </template>
                    <template #matlCdTemplate>
                      <div>Material<br />Code</div>
                    </template>
                    <template #reqDlyDteTemplate>
                      <div>Req.Dly.<br />Date</div>
                    </template>
                    <template #canQtyTemplate>
                      <div>Req.<br />Can</div>
                    </template>
                    <DxColumn caption="HVS Receive Information" width="24%" data-type="string" :allow-editing="false"
                              alignment="center" :visible="true">
                      <DxColumn  caption="Recieve Date" width="12%" data-type="string"
                                 :allow-editing="false" alignment="center" :visible="true">
                        <DxColumn data-field="recDte" caption="Por No" width="12%" data-type="string"
                                  :allow-editing="false" alignment="center" :visible="true" />
                      </DxColumn>
                      <DxColumn  caption="POR Status" width="12%" data-type="string"
                                 :allow-editing="false" alignment="center" :visible="true">
                        <DxColumn data-field="porStatus" caption="HVS PIC" width="12%" data-type="string"
                                  :allow-editing="false" alignment="center" :visible="true" />
                      </DxColumn>
                    </DxColumn>

                    <DxColumn caption="HVS PO Information" width="30%" data-type="string" :allow-editing="false"
                              alignment="center" :visible="true">

                      <DxColumn data-field="poDte" caption="Po Date" width="10%" data-type="string"
                                :allow-editing="false" alignment="center" :visible="true" />

                      <DxColumn data-field="poUprice" caption="Unit Price" width="8%" data-type="string"
                                :allow-editing="false" alignment="center" :visible="true" />

                      <DxColumn data-field="estPoUsd" caption="EST.PO Amount" width="10%" data-type="string"
                                :allow-editing="false" alignment="center" :visible="true" header-cell-template="estPoUsdTemplate"/>

                    </DxColumn>

                    <template #estPoUsdTemplate>
                      <div>EST.PO<br />Amount</div>
                    </template>

                    <DxColumn data-field="shippDate" caption="Shipping Date" width="10%" data-type="string"
                              :allow-editing="false" alignment="center" :visible="true" header-cell-template="shippDateTemplate"/>

                    <template #shippDateTemplate>
                      <div>Shipping<br />Date</div>
                    </template>

                    <DxColumn caption="HVS Warehouse Information" width="20%" data-type="string" :allow-editing="false"
                              alignment="center" :visible="true" header-cell-template="whInfo" >
                      <DxColumn  caption="WH Date" width="10%" data-type="string"
                                 :allow-editing="false" alignment="center" :visible="true">
                        <DxColumn data-field="whDte" caption="WH Qty" width="10%" data-type="string"
                                  :allow-editing="false" alignment="center" :visible="true" />
                      </DxColumn>

                      <DxColumn data-field="whAmt" caption="Est.W/house Amount" width="10%" data-type="string"
                                :allow-editing="false" alignment="center" :visible="true" header-cell-template="whAmtTemplate"/>
                    </DxColumn>

                    <template #whInfo>
                      <div>HVS Warehouse<br />Information</div>
                    </template>
                    <template #whAmtTemplate>
                      <div>Est.W/H<br />Amount</div>
                    </template>

                    <DxColumn caption="HVS Issue Information" width="20%" data-type="string" :allow-editing="false"
                              alignment="center" :visible="true">
                      <DxColumn  caption="Issue Date" width="10%" data-type="string"
                                 :allow-editing="false" alignment="center" :visible="true">
                        <DxColumn data-field="issDte" caption="Issue Qty" width="10%" data-type="string"
                                  :allow-editing="false" alignment="center" :visible="true" />
                      </DxColumn>

                      <DxColumn data-field="issAmt" caption="Issue Amount" width="10%" data-type="string"
                                :allow-editing="false" alignment="center" :visible="true" header-cell-template="issAmtTemplate"/>
                    </DxColumn>

                    <template #issAmtTemplate>
                      <div>Issue<br />Amount</div>
                    </template>

                    <DxPaging :enabled="true" :page-size="20" />
                  </DxDataGrid>
                </v-col>
              </v-row>
            </v-layout>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import baseview from '@/components/base/baseview.vue' // 
import BaseDataGrid from '@/components/base/BaseDataGrid.vue'
import drawingPagePop from '@/views/hip/common/drawingPagePop'
import { epmsb200List, epmsb200Xls } from '@/api/view/hip/B/epmsb200.js'
import { getDateFormat } from '@/utils/common.js'
import DxDateBox from 'devextreme-vue/date-box'
import { getNumComma } from '@/utils/common.js'

export default {
  name: 'epmsb200',
  mixins: [baseview, BaseDataGrid],
  components: {
    ICardVertical,
    'i-card-top': iCardTop,
    DxDateBox,
    drawingPagePop
  },
  data() {
    return {
      gridMainList: [],
      epmsb200Ref: "epmsb200Ref",
      makerCd: this.$store.state.user.makerCd,
      matlCd:'',
      startDate: '',
      endDate: '',

      stDte: '',
      edDte: '',

      fact: {
        select: { name: 'All', cd: '0' },
        items: [
          { name: 'All', cd: '0' },
          { name: 'Suoi Dau', cd: '1' },
          { name: 'Van Thai', cd: '2' },

        ]
      },

      reqDiv: {
        select: { name: 'All', cd: '0' },
        items: [
          { name: 'All', cd: '0' },
          { name: 'By Send Date', cd: '1' },
          { name: 'By Warehouse Date', cd: '2' },
          { name: 'By Issue Date', cd: '3' }
        ]
      }
    }
  },
  computed: {
    gridMainInstance() {
      return this.GetDataGrid(this.epmsb200Ref)
    },
  },
  methods: {
    getStrFormat(date) {
      this.stDte = getDateFormat(date)
      return getDateFormat(date)
    },
    getEndFormat(date) {
      this.edDte = getDateFormat(date)
      return getDateFormat(date)
    },
    formatPrice(value) {
      return getNumComma(value)
    },

    btnRetrieve() {

      this.doSearchMain()
    },
    async doSearchMain() {

      this.openLoading('searching')
      let params = {
        makerCd: this.makerCd,
        matlCd: this.matlCd === null ? '' : this.matlCd ,
        fac: this.makerCd === '90263' || this.makerCd === '95987' ? this.fact.select.cd : '3',
        div: this.reqDiv.select.cd,
        stDte: this.stDte,
        edDte: this.edDte
      }
      console.log(params)
      await epmsb200List(params).then(res => {
        //this.gridMainList = res.list
        let list = []
        let cnt = 1;
        res.list.forEach(e => {
          list.push(
              {
                id: cnt++, rnum: e.rnum, facNm: e.facNm, reqNo: e.reqNo, shipNo: e.matlSpec, pntCd: e.matlSpec, matlCd: e.matlSpec,
                perCanLtr: e.matlSpec, qty: e.matlSpec, canQty: e.matlSpec, reqDlyDte: e.matlSpec, recDte: e.recDte, porStatus: e.porStatus,
                poDte: e.poDte, poUprice: e.poUprice, estPoUsd: e.estPoUsd, shippDate: e.shippDate, whDte: e.whDte, whAmt: e.whAmt,
                issDte: e.issDte, issAmt: e.issAmt

              },
              {
                id: cnt++, rnum: e.rnum, facNm: e.facNm, reqNo: e.sendDte, shipNo: e.shipNo, pntCd: e.pntCd, matlCd: e.matlCd,
                perCanLtr: e.perCanLtr, qty: e.qty, canQty: e.canQty, reqDlyDte: e.reqDlyDte, recDte: e.porNo, porStatus: e.buyerNm,
                poDte: e.poDte, poUprice: e.poUprice, estPoUsd: e.estPoUsd, shippDate: e.shippDate, whDte: e.whQty, whAmt: e.whAmt,
                issDte: e.issQty, issAmt: e.issAmt
              },
          )
        });
        this.gridMainList = list


      }).finally(() => {
        //console.log(this.gridMainList);
        this.endLoading();
      })
    },

    btnExcel() {
      this.openLoading('Saving Excel!')
      let params = {
        makerCd: this.makerCd,
        matlCd: this.matlCd,
        fac: this.makerCd === '90263' || this.makerCd === '95987' ? this.fact.select.cd : '3',
        div: this.reqDiv.select.cd,
        stDte: this.stDte,
        edDte: this.edDte
      }

      epmsb200Xls(params).finally(() => {
        this.endLoading();
      })

    },
    //cell merge
    cellPrepared(e) {
      if (e.rowType === 'data') {
        if (e.column.caption === 'No' || e.column.caption === 'Factory' || e.column.caption === 'Po Date' ||
            e.column.caption === 'Unit Price' || e.column.caption === 'EST.PO Amount' || e.column.caption === 'Shipping Date' ||
            e.column.caption === 'Est.W/house Amount' || e.column.caption === 'Issue Amount') {
          if (e.value == e.component.cellValue(e.rowIndex + 1, e.column.dataField) && e.values[0] == e.component.cellValue(e.rowIndex + 1, 'rnum')) {
            e.cellElement.setAttribute('rowspan', 2)
          } else {
            e.cellElement.style.display = 'none'
          }
        }

        if (e.column.name === 'shippDate') {
          e.cellElement.style.backgroundColor = "#FFCC99"
        }
        if (e.column.caption === 'Issue Date' || e.column.caption === 'Issue Qty' || e.column.caption === 'Issue Amount') {
          e.cellElement.style.backgroundColor = "#FFFF99"
        }
        if (Number(e.rowIndex) % 2 === 0) {
          if (e.columnIndex === 3) {
            e.cellElement.setAttribute('colspan', 7)
          } else if (e.columnIndex > 3 && e.columnIndex <= 9) {
            e.cellElement.style.display = 'none'
          }
        }
        else {
          if (e.column.caption === 'Req.Qty' || e.column.caption === 'Req.Can' || e.column.caption === 'Req.Dly.Date') {
            e.cellElement.style.backgroundColor = "#FFCC99"
          }
        }

      } else if (e.rowType === 'header') {

        if (e.column.caption === 'Shipping Date') {
          e.cellElement.style.backgroundColor = "#FFCC99"
        }
        if (e.column.caption === 'Issue Date' || e.column.caption === 'Issue Qty' || e.column.caption === 'Issue Amount' || e.column.caption === 'HVS Issue Information') {
          e.cellElement.style.backgroundColor = "#FFFF99"
        }
      }
    }

  },
  mounted() {
    var date = new Date();
    this.startDate = new Date(date.getFullYear(), date.getMonth() - 2, 0)

    this.endDate = new Date(date.getFullYear(), date.getMonth() + 4, 0);

    if (this.makerCd !== '90263' && this.makerCd !== '95987') {
      this.fact = {
        select: { name: 'Others', cd: '3' },
        items: [
          { name: 'Others', cd: '3' }]
      }
    } else {
      this.fact = {
        select: { name: 'All', cd: '0' },
        items: [
          { name: 'All', cd: '0' },
          { name: 'Suoi Dau', cd: '1' },
          { name: 'Van Thai', cd: '2' },

        ]
      }
    }

    this.gridMainInstance.option('defaultPaging', false)
  }
}

</script>

<style scoped></style>